module.exports = __webpack_public_path__ + "img/recentl_ycreated_check.697f2dcb.svg";